import React, { useState,useEffect } from 'react';
import { useSelector } from 'react-redux';
import dooctilogo from "../assets/images/logoinlinewhite.png";
import person from "../assets/images/person.svg"
import "../assets/css/comtemplete.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPowerOff } from '@fortawesome/free-solid-svg-icons';
import skyfalllogo from "../assets/images/SKyfalllogo.png"
import gtawklogo from "../assets/images/gtawk.png"

// import person from "../assets/images/person.svg";



function Comtemplete({ children,toggleUserOptions, badge, logout, handleSetBadge,awayOptionsOpen }) {
    const backgroundstate = useSelector((state) => state.bgpermission)
    const queuestatus =JSON.parse(localStorage.getItem('queuelogin'))
 const agent_status =backgroundstate.setagentstatus
 const agentstatus=localStorage.getItem('agentstatus')
 const [logo,setLogo] = useState()
     useEffect(() => {
        var interval = null;
        console.log('=====>', window.location.hostname);
        const baseURL = window.location.hostname;
        // const baseURL = "crm-dev.doocti.com/";
        if (baseURL.includes('doocti.com')) {
            setLogo(dooctilogo)

        } else if (baseURL.includes('gtawk.com')) {
            setLogo(gtawklogo)
        } else if (baseURL.includes('skyfalltech.in')) {
            setLogo(skyfalllogo)
        } else if (baseURL.includes('localhost')) {
            // setLogo(dooctilogo)
            setLogo(skyfalllogo)
        } else {
            setLogo(dooctilogo)
        }
      
    }, []);



 
  return (
    <div>
      <div className='topheader'>
      
      <header class="header-top dropshadow">
    <div class="header-content ">

    <img className="logo-image" src={logo} />
     
   {!agent_status && (
     <div>
        
     <div className="button-logout">



        <div className="betweenspace">
            <div className="user-options" id="userOptions">
            {badge !== 'Online' &&  <div className="option" id="onlineOption" onClick={() => handleSetBadge('Online')}>
                    Online
                </div>
   }
               
               {badge !== 'Away' &&   <div className="option" id="awayOption" onClick={() => handleSetBadge('Away')}>
                    Away
                </div> }



            </div>
            <img className="userlogo" src={person} onClick={toggleUserOptions} />
            {badge === 'Online' && <div className="badge-green"></div>}
            {badge === 'Offline' && <div className="badge-red"></div>}
            {badge === 'Away'  && <div className="badge-grey"></div>}


            {badge === 'Away' && awayOptionsOpen && (
 
                <div className="badge-grey">
                    <div className="away-options">
                        <div className="option" onClick={() => handleSetBadge('Lunch')}>
                            Lunch
                        </div>
                        <div className="option" onClick={() => handleSetBadge('Meeting')}>
                            Meeting
                        </div>
                        <div className="option" onClick={() => handleSetBadge('Break')}>
                            Break
                        </div>
                    </div>
                </div>
            )}

        </div>
        {/* <button className="userlogout" onClick={logout} style={{ color: 'white',border:'none',width: '50px' }} >
            <FontAwesomeIcon icon={faPowerOff} />
        </button> */}

        <button className="userlogout" onClick={logout} style={{ color: 'white', border: 'none', fontSize: '24px',cursor:"pointer" }}>
                                        <FontAwesomeIcon title="Logout" icon={faPowerOff} />
                                    </button>
    </div>
    


</div>  
   )}
  
  
             
             
             


      
    
    </div>
</header>


      </div>
      <div className='contentspace'>
        
      {children}



      </div>
    </div>

  )
}
export default Comtemplete;
